export const variables = {
  fontText: '"Open Sans", sans-serif',
  colorDecorator: '#8B231D',
  colorWhite: '#fff',
  colorMainText: '#000',
  colorMainTextOpacity: '#000000A6',
  colorBorder: '#E9E9E9',
  colorBackground: '#F1F3F6',
  colorGrey: '#788195',
  colorGreyDarkest: '#555c6c',
  colorScrollbar: '#e8e8e8',
  colorDarkestGrey: '#c5c5c5',
  colorInfo: '#1890ff',
  colorSuccess: '#3CBF15',
  colorError: '#FF0000',
  colorDisabled: '#00000040', //color disable text antd
};
